<template>
  <v-dialog
    value="value"
    :width="1000"
    :max-width="1000"
    @click:outside="closeSplash">
    <v-card tile elevated>
      <v-toolbar elevated class="mb-4" color="primary">
        <v-toolbar-title>
          <v-card-title class="white--text">
            Welcome to the Item Master Portal
          </v-card-title>
          <v-card-subtitle class="grey--text text--lighten-4">
            You can use the filters menu above to locate items using one or more search criteria.
          </v-card-subtitle>
        </v-toolbar-title>
      </v-toolbar>
      <v-img 
        class="mx-auto"
        :src="require(`@/assets/splash-gif.gif`)"
        alt="Splash page gif"
        :width=800>
      </v-img>
      <v-card-text class="black--text" v-html="copyText">
      </v-card-text>
      <v-toolbar flat color="toolbar">
        <v-spacer/>
        <v-btn color="primary"
          @click="closeSplash">Close</v-btn>
        <v-spacer/>
      </v-toolbar>
    </v-card>
  </v-dialog>
</template>
<script>

export default {
  data () {
    return {
      splashScreen: false,
      copyText: `To enhance your search experience in the Item Master Portal, you can utilize the filters dropdown box. This feature allows you to swiftly narrow down your search results by selecting specific criteria relevant to the items you are looking for. Simply click on the filters dropdown box at the top of the page, choose your desired filters, and apply them to refine the displayed items. This tool is designed to help you find exactly what you need with greater precision and efficiency.`
    }
  },
  name: 'ItemMasterSplash',
  mixins: [],
  props: {
    value: Boolean
  },
  created () {
    this.nonTableHeight = 380
  },
  computed: {
  },
  methods: {
    closeSplash () {
      this.$emit('close')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/items/itemMasterSplash.vue